<div class="my-3">
  <button
    mat-raised-button
    class="ms-3"
    routerLink="/evaluator/dashboard/scanner"
  >
    Back
  </button>
</div>
<mat-card>
  <mat-card-content
    class="d-flex flex-column justify-content-center align-items-center"
  >
    <h4 style="color: #313131">
      <strong>E-signature Details</strong>
    </h4>
    <img *ngIf="avatarUrl" [src]="avatarUrl" alt="User Avatar" />
    <div class="d-flex justify-content-center">
      <mat-chip-list class="mt-3">
        <mat-chip class="chip mx-1">
          <mat-icon class="me-3 text-success">person</mat-icon>
          <div class="d-flex flex-column">
            <span class="text-muted">Evaluator Full Name:</span>
            <span>John E. Dulay</span>
          </div>
        </mat-chip>
        <mat-chip class="chip mx-1">
          <mat-icon class="me-3 text-success">mail</mat-icon>
          <div class="d-flex flex-column">
            <span class="text-muted">Email Address:</span>
            <span> john@gmail.com</span>
          </div>
        </mat-chip>
        <mat-chip class="chip mx-1">
          <mat-icon class="me-3 text-success">work</mat-icon>
          <div class="d-flex flex-column">
            <span class="text-muted">Role:</span>
            <span>CHSO Sanitary Engineer</span>
          </div>
        </mat-chip>
        <mat-chip class="chip mx-1">
          <mat-icon class="me-3 text-success">description</mat-icon>
          <div class="d-flex flex-column">
            <span class="text-muted">Document:</span>
            <span>Work Permit</span>
          </div>
        </mat-chip>
        <mat-chip class="chip mx-1">
          <mat-icon class="me-3 text-success">pin</mat-icon>
          <div class="d-flex flex-column">
            <span class="text-muted">Application Number:</span>
            <span>APN-2024-000-001</span>
          </div>
        </mat-chip>
        <mat-chip class="chip mx-1">
          <mat-icon class="me-3 text-success">pin</mat-icon>
          <div class="d-flex flex-column">
            <span class="text-muted">Applicant's Full Name:</span>
            <span>Jane Garcia</span>
          </div>
        </mat-chip>
        <mat-chip class="chip mx-1">
          <mat-icon class="me-3 text-success">plagiarism</mat-icon>
          <div class="d-flex flex-column">
            <span class="text-muted">QR Code Coordinates:</span>
            <span>X: 150px </span>
            <span>Y: 230px </span>
          </div>
        </mat-chip>
        <mat-chip class="chip mx-1">
          <mat-icon class="me-3 text-success">today</mat-icon>
          <div class="d-flex flex-column">
            <span class="text-muted">QR Generation Details:</span>
            <span>January 8, 2024 </span>
            <span>4:00 PM</span>
          </div>
        </mat-chip>
        <mat-chip class="chip mx-1">
          <mat-icon class="me-3 text-success">task_alt</mat-icon>
          <div class="d-flex flex-column">
            <span class="text-muted">Date of Signature:</span>
            <span>January 8, 2024 </span>
            <span>4:04 PM</span>
          </div>
        </mat-chip>
      </mat-chip-list>
    </div>
  </mat-card-content>
</mat-card>
